import styled from 'styled-components';
import { Box, Card, Paper } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const Container = styled.div`
  padding: 1rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background-color: #1a1e24;
  min-height: calc(100vh - 60px);

  @media (max-width: 600px) {
    padding: 0.5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  gap: 1rem;
`;

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
`;

export const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  gap: 12px;
`;

export const ContentContainer = styled.div`
  width: 100%;
`;

export const MatchCard = styled.div`
  padding: 1rem;
  border-radius: 8px;
  background-color: #212830;
  height: 100%;
  border-left: 4px solid #1976d2;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4),
              0 4px 8px rgba(0, 0, 0, 0.2);

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

export const Teams = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
  padding: 0.75rem;
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const Team = styled.div`
  flex: 1;
  text-align: center;
  padding: 0.5rem;
  overflow: hidden;
`;

export const MatchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
  background-color: rgba(20, 25, 30, 0.95);
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(30, 40, 50, 0.8);

  @media (max-width: 600px) {
    padding: 10px 8px;
  }
`;

export const ScoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
  min-width: 80px;
  margin: 0 auto;

  @media (max-width: 480px) {
    min-width: 70px;
    padding: 4px 8px;
  }
`;

export const ReasonsContainer = styled.div`
  max-height: 80px;
  overflow-y: auto;
  margin-bottom: 12px;
  padding: 10px;
  background-color: rgba(26, 32, 39, 0.5);
  border-radius: 6px;
  border-left: 2px solid rgba(25, 118, 210, 0.6);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
  }
`;

type OpportunityCardProps = {
  valueScore: number;
};

export const OpportunityCard = styled.div<OpportunityCardProps>`
  padding: 1rem;
  border-radius: 8px;
  background-color: #212830;
  border-left: 4px solid ${({ valueScore }) => {
    if (valueScore >= 75) return '#4caf50';
    if (valueScore >= 50) return '#ff9800';
    return '#757575';
  }};
  height: 100%;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4),
              0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

export const DetailedOpportunityCard = styled.div<OpportunityCardProps>`
  background-color: #212830;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: ${({ valueScore }) => {
    if (valueScore >= 80) return '#4caf50';
    if (valueScore >= 50) return '#ff9800';
    return '#757575';
  }};
  }
`;

export const MatchInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  background-color: rgba(26, 32, 39, 0.8);
  border-radius: 8px;
  padding: 0.75rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
`;

export const TeamInfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;

  h6 {
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    color: #ffffff;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  h4 {
    font-weight: bold;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    color: #ffffff;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.25rem;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const LeagueIndicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #1976d2;
  margin-right: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
`;

type ValueBadgeProps = {
  value: number;
};

export const ValueBadge = styled.span<ValueBadgeProps>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  background-color: ${({ value }) => {
    if (value >= 75) return 'rgba(76, 175, 80, 0.25)';
    if (value >= 50) return 'rgba(255, 152, 0, 0.25)';
    return 'rgba(224, 224, 224, 0.15)';
  }};
  color: ${({ value }) => {
    if (value >= 75) return '#8bc34a';
    if (value >= 50) return '#ffb74d';
    return '#e0e0e0';
  }};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
`;

export const ValueIndicator = styled.span<{ value: number }>`
  background-color: ${props =>
    props.value >= 90 ? 'rgba(76, 175, 80, 0.25)' :
      props.value >= 70 ? 'rgba(255, 152, 0, 0.25)' :
        'rgba(244, 67, 54, 0.25)'};
  color: ${props =>
    props.value >= 90 ? '#8bc34a' :
      props.value >= 70 ? '#ffb74d' :
        '#ef5350'};
  padding: 4px 10px;
  border-radius: 16px;
  font-weight: bold;
  font-size: 0.875rem;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
`;

export const LiveBadge = styled.div`
  background-color: #f44336;
  color: white;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.6rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  animation: pulse 1.5s infinite;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  text-transform: uppercase;
  white-space: nowrap;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const FinishedBadge = styled.div`
  background-color: #333;
  color: white;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.6rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
`;

export const OpportunityCardLive = styled(Paper)`
  padding: 14px 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;
  background-color: #212830;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4),
              0 4px 8px rgba(0, 0, 0, 0.2),
              0 0 0 1px rgba(40, 50, 60, 0.8);
  margin-bottom: 16px;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 12px 10px;
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    padding: 10px 8px;
  }
`;

export const MetricBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 6px;
  background-color: rgba(26, 32, 39, 0.8);
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;

  @media (max-width: 480px) {
    padding: 6px 4px;
  }
`;

export const FinishedGameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  z-index: 1;
  backdrop-filter: blur(2px);

  span {
    background-color: #f44336;
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-weight: bold;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    white-space: nowrap;

    @media (max-width: 400px) {
      padding: 4px 12px;
      font-size: 0.8rem;
    }
  }
`;

export const TeamName = styled.div`
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
  padding: 0 2px;

  @media (max-width: 400px) {
    font-size: 0.8rem;
  }
`;